import axios from 'axios';

const BASE_URL = 'https://apicarto.ign.fr/api/codes-postaux/communes';

export default {
  /* Public IGN API : maps a French postal code to its city names */
  getCommunes: (zipCode) => axios.get(`${BASE_URL}/${zipCode}`)
};
